import type { FetchRequestError } from "@lib/errors";
import type { RemoveFirstArgument } from "@lib/typeHelpers";

import type { AllRouteEndpoints } from "../routeTypes";
import type { CacheKeyParam, InternalGetFetcherFunctionWithShadowError, RootCacheKey } from "../types";

/**
 * Strongly type a GET fetcher function with the error class it throws
 *
 * Since any server error is possible, this forces an intersection of the specified error type and FetchRequestError
 */
export const createGetFetcherFunctionWithShadowError =
  <Error extends FetchRequestError>() =>
  <
    CacheKey extends AllRouteEndpoints,
    QueryKey extends readonly [rootKey: RootCacheKey<CacheKey>, ...originalKey: CacheKeyParam[]],
    Args extends RemoveFirstArgument<QueryKey>,
    Result,
  >(
    fetcher: InternalGetFetcherFunctionWithShadowError<Error, CacheKey, QueryKey, Args, Result>
  ) =>
    fetcher;
